module.exports = __webpack_public_path__ + "img/zhongwei.a1fc8049.png";